import type { Locale, LocalizedPath } from '@packages/config/src/default';

export const getLocalizedPath = (pathConfig: LocalizedPath, locale: string) =>
  pathConfig[locale as Locale] ?? pathConfig.default;
